import { WidgetEventStruct } from "../../widget-event.struct";
import { LogicalWidgetEnum } from "../../../enums";

export class LogicalWidgetEventStruct extends WidgetEventStruct {
  public event_logical_widget_type: LogicalWidgetEnum;
} 